import { Directive, HostListener, inject, input, output, Type } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { FormDialogComponent } from "./form-dialog-component/form-dialog-component.component";

@Directive({
  selector: "[libFormDialog]",
})
export class FormDialogDirective {
  #matDialog = inject(MatDialog);

  // Signal Inputs
  // Flavor Text
  $dialogTitle = input<string>("Form Dialog Title", { alias: "dialogTitle" });
  $submitButtonText = input<string>("Submit", { alias: "submitButtonText" });
  $closeButtonText = input<string>("Close", { alias: "cancelButtonText" });
  // Dialog Dimensionals
  $dialogWidth = input<string>("100%", { alias: "dialogWidth" });
  $dialogMaxWidth = input<string>("500px", { alias: "dialogMaxWidth" });
  $dialogHeight = input<string>("auto", { alias: "dialogHeight" });
  $dialogMaxHeight = input<string>("auto", { alias: "dialogMaxHeight" });
  // Form Inputs
  $formComponent = input.required<Type<any>>({ alias: "formComponent" });
  $formInput = input<any>(null, { alias: "formInput" });
  $isDisabled = input<boolean>(false, { alias: "disabled" });

  // Signal Ouput
  $confirmed = output<any>({ alias: "confirmed" });

  @HostListener("click")
  open() {
    const dialogRef = this.#matDialog.open(FormDialogComponent, {
      width: this.$dialogWidth(),
      maxWidth: this.$dialogMaxWidth(),
      height: this.$dialogHeight(),
      maxHeight: this.$dialogMaxHeight(),
      data: {
        title: this.$dialogTitle(),
        closeLabel: this.$closeButtonText(),
        submitLabel: this.$submitButtonText(),
        formComponent: this.$formComponent(),
        formInput: this.$formInput(),
        disabled: this.$isDisabled(),
      },
    });

    dialogRef.afterClosed().subscribe((val) => {
      if (val) this.$confirmed.emit(val);
    });
  }
}
